export const PROJECTS_SUBSCRIPTIONS_REDUCER_KEYS = {
  REDUCER: 'projectSubscriptions',
  BY_ID: 'byId',
}
